<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col mt-4">
        <div id="editor"></div>
        <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
        <div class="text-center">
          <span
            class="btn btn-success mt-4"
            v-show="!onload"
            @click="handleSave()"
            >Guardar cambios</span
          >
          <span class="btn btn-success mt-4" v-show="onload">Guardando...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import { mapState } from "vuex";
import Api from "../../tools/Api2";
const CKEditor = require("ckeditor4-vue");
Vue.use(CKEditor);
export default {
  name: "EditTyc",
  data() {
    return {
      onload: true,
      editorData: "<p>Ejemplo de TYC de Treidblue.</p>",
      editorConfig: {
        // Incluye el plugin de justificación
        extraPlugins: "justify",
        // Configura la barra de herramientas
        toolbar: [
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
            ],
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
            ],
          },
          {
            name: "alignment",
            items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
            ],
          }, // Aquí se añaden los botones de justificación
          { name: "links", items: ["Link", "Unlink"] },
          {
            name: "insert",
            items: ["Image", "Table", "HorizontalRule", "SpecialChar"],
          },
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
        ],
        // Otras configuraciones adicionales
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    handleSave() {
      this.onload = true;
      console.log(this.editorData);
      Api("tyc")
        .post({ html: this.editorData })
        .then((res) => {
          if (!res.error) location.reload();
        })
        .finally(() => {
          this.onload = false;
        });
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
  },
  mounted: function() {
    Api("tyc")
      .get()
      .then((res) => {
        if (!res.error) this.editorData = res.text;
      })
      .finally(() => {
        this.onload = false;
      });
  },
};
</script>
